import {
  AggregatedActivityAction,
  AggregatedActivityState,
} from 'store/aggregated/aggregatedActivity';
import { domainUtility } from 'utility';

const initialState: AggregatedActivityState = { allIds: [], byId: {} };

const aggregatedActivityReducer = (
  state: AggregatedActivityState = initialState,
  action: AggregatedActivityAction,
): AggregatedActivityState => {
  switch (action.type) {
    case 'aggregated/aggregatedActivity/ADD':
      return domainUtility.add(state, action.payload);
    case 'aggregated/aggregatedActivity/SET':
      return domainUtility.set(state, action.payload);
    case 'aggregated/aggregatedActivity/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'aggregated/aggregatedActivity/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'aggregated/aggregatedActivity/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default aggregatedActivityReducer;
